import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class CouponService {

    public Coupondata: any;

    constructor(private httpService: HttpService) { }

    getCouponByclientId(id: any) {
        const url = `${environment.CouponApiendpoint}/couponListByClient/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getallCoupon() {
        const url = `${environment.CouponApiendpoint}/get-coupon/`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    addCoupon(data: any): Observable<any> {
        const url = `${environment.CouponApiendpoint }/addcoupon`
        return this.httpService.post(url, data, this.httpService.headers)
    }


    deleteCoupon(id: any) {
        const url = `${environment.CouponApiendpoint}/deletecoupon/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    obtainCoupon(user: any) {
        const url = `${environment.CouponApiendpoint}/listcoupanbyId/${user}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    editCoupon(data: any, Coupon: any): Observable<any> {
        const url = `${environment.CouponApiendpoint}/updatecoupon/${Coupon}`

        return this.httpService.put(url, data, this.httpService.headers)
    }

    // editLablocation(data: any, Lablocation: any): Observable<any> {
    //     const url = `${environment.LablocationApiendpoint}/update_lab_location/${Lablocation}`
    //     return this.httpService.put(url, data, this.httpService.headers)
    // }

    updateStatus(id: any, status: any): Observable<any> {



        let data ;
        if (status == 'Active') {
            data = {
                status: 'Inactive'
            };
        }else{
            data = {
                status: 'Active'
            };
        }
        const url = `${environment.CouponApiendpoint}/Coupon-change-status/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }



    obtainCoupons(search: any) {
        const url = `${environment.CouponApiendpoint}/couponList?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllCityById(id: any) {
        const url = `${environment.CouponApiendpoint}/cities-by-state-id/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllCity() {
        const url = `${environment.CouponApiendpoint}/cities?d=all`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllAreacodeById(id: any) {
        const url = `${environment.CouponApiendpoint}/area-codes-by-city-id/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    // createCoupon(data: any): Observable<any> {
    //   const url = `${environment.CouponApiEndpoint}/Coupons`;
    //   return this.httpService.post(url, data, this.httpService.headers);
    // }

    getCoupon(data: any): Observable<any> {
        this.Coupondata = [
            {
                id: '1',
                emp_code: '123',
                first_name: 'Abhishek',
                last_name: 'Anand',
                email: 'temp@email.com',
                phone: '25012021',
                status: 'Active',
                city: 'Dehradun',
                state: 'Uttarakhand',
            },
        ];

        return this.Coupondata;
    }
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
